import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import useLatestVersion from 'hooks/data/versions/useLatestVersion';

const Root = () => {
  const { data: latestVersion, isLoading } = useLatestVersion();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !latestVersion) return;

    navigate(`/${latestVersion?.version}/${latestVersion?.system_model}`, { replace: true });
  }, [latestVersion, navigate, isLoading]);

  return null;
};

export default Root;
